
import { mapGetters } from 'vuex'
export default {
    name: 'Flow',

    computed: {
        ...mapGetters({
            orderFlow: 'ry/orderFlow'
        })
    },
    methods: {
        filters(list) {
            let arr = []
            list.forEach((item) => {
                item['_custom_status'] = 1 // 已完成

                if (item?.orderFlow?.length > 0) {
                    // 有未完成的节点
                    if (item?.orderFlow?.some(vo => vo.status === 0)) {
                        item['_custom_status'] = 0 // 未完成
                    }
                    arr.push(item)
                }
            })
            return arr
        }
    }
}
